/**
 * What it takes to render a Hebrew line correctly inside an English interface.
 *
 * A sentence-final question mark or full stop is a bidi-neutral character, and
 * neutrals at the end of a line resolve to the *paragraph* direction rather
 * than to the direction of the words they follow. With the interface in
 * English the paragraph is left-to-right, so "איזהו מקומן של זבחים?" renders
 * its question mark at the wrong end. text-align only moves the block; it does
 * not decide which end the punctuation belongs to.
 *
 * `direction` states it in CSS as well as in the attribute, since an inherited
 * rule can otherwise win. `unicode-bidi: isolate` makes each line its own bidi
 * context, so the surrounding page can no longer claim its trailing
 * punctuation. `textAlign: start` is used rather than `right` because the app
 * flips MUI styles through stylis when the interface turns Hebrew, and would
 * flip a literal `right` into `left`.
 *
 * Pair it with dir="rtl" on the element.
 */
export const HEBREW_LINE = {
  direction: 'rtl' as const,
  unicodeBidi: 'isolate' as const,
  textAlign: 'start' as const,
};
